import { render } from "./SaleSummaryBusinessHealthCard.vue?vue&type=template&id=40139573&scoped=true"
import script from "./SaleSummaryBusinessHealthCard.vue?vue&type=script&lang=js"
export * from "./SaleSummaryBusinessHealthCard.vue?vue&type=script&lang=js"

import "./SaleSummaryBusinessHealthCard.vue?vue&type=style&index=0&id=40139573&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40139573"]])

export default __exports__